export const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL || 'https://barber-eleganze.fr';

export const RESERVATION_URL = 'https://www.planity.com/barber-eleganze-86180-buxerolles';
export const INSTAGRAM_URL = 'https://www.instagram.com/barber_eleganze?igsh=MXk4NXh2eDZzc3Zy';
export const TIKTOK_URL = 'https://www.tiktok.com/@eleganze_barber?_r=1&_t=ZN-94BXCZvfJp8';
export const GOOGLE_BUSINESS_URL = 'https://share.google/Rsnozr5P5xYYfBLO2';
export const ADDRESS_TEXT = '26 Rue de Terrageaux, 86180 Buxerolles';
export const MAP_LABEL = 'Carte de ELEGANZE BARBER';
export const PHONE_DISPLAY = '06 67 58 35 48';
export const PHONE_TEL = '+33667583548';
export const MAP_LINK_URL =
  'https://www.google.com/maps/search/?api=1&query=26+Rue+de+Terrageaux,+86180+Buxerolles';

export const MAP_EMBED_URL =
  'https://maps.google.com/maps?q=26%20Rue%20de%20Terrageaux%2C%2086180%20Buxerolles%2C%20France&t=&z=15&ie=UTF8&iwloc=&output=embed';
